function packMegaMenuColumns() {
  var containers = document.querySelectorAll('.mega-menu__columns');
  containers.forEach(function(container) {
    if (container.dataset.packed) return;
    var columns = [].slice.call(container.children);
    if (!columns.length || columns[0].classList.contains('mega-menu__column-group')) return;

    var maxHeight = 0;
    columns.forEach(function(c) {
      if (c.offsetHeight > maxHeight) maxHeight = c.offsetHeight;
    });

    var groupHeight = function(group) {
      var h = 0;
      group.forEach(function(col) { h += col.offsetHeight; });
      return h;
    };

    var groups = [];
    columns.forEach(function(col) { groups.push([col]); });

    var changed = true;
    while (changed) {
      changed = false;
      for (var i = 0; i < groups.length - 1; i++) {
        if (groupHeight(groups[i]) + groupHeight(groups[i + 1]) <= maxHeight) {
          groups[i] = groups[i].concat(groups[i + 1]);
          groups.splice(i + 1, 1);
          changed = true;
          break;
        }
      }
    }

    container.innerHTML = '';
    groups.forEach(function(g) {
      var wrapper = document.createElement('div');
      wrapper.className = 'mega-menu__column-group';
      g.forEach(function(c) { wrapper.appendChild(c); });
      container.appendChild(wrapper);
    });
    container.dataset.packed = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', packMegaMenuColumns);
} else {
  packMegaMenuColumns();
}
document.addEventListener('shopify:section:load', packMegaMenuColumns);
